// src/config.js
export const USER_ROLES = {
  SUPERADMIN: 'SuperAdmin',
  ADMIN: 'Admin',
  ENSEIGNANT: 'Enseignant',
  VISITEUR: 'Visiteur',
};

export const NAV_LINKS = {
  [USER_ROLES.SUPERADMIN]: [
    { path: "/Mes_Inspections", label: 'Inspections' },
    { path: '/Mes_Ecoles', label: 'Ecoles' },
    { path: '/Mes_Cours', label: 'Cours' },
    { path: "/Mes_Sections", label: 'Sections' },
    { path: '/Mes_Classes', label: 'Classes' },
    { path: '/Mes_Cours-Classe', label: 'Repartition' },
    { path: '/Programme', label: 'Programme' },
  ],
  [USER_ROLES.ADMIN]: [
    { path: '/Sections', label: 'Sections' },
    { path: '/Classes', label: 'Classes ' },
    { path: '/Cours', label: 'Cours' },
    { path: '/Elèves', label: 'Elèves' },
    { path: '/Inscription', label: 'Inscription ' },
    { path: '/Enseignants', label: 'Enseignants' },
    { path: '/Conduite', label: 'Conduite'},
    { path: '/Délibération', label: 'Délibération' },
    
  ],
  [USER_ROLES.ENSEIGNANT]: [
    { path: '/Encodage', label: 'Encodage' },
    { path: '/Proclamation', label: 'Résultat' },
    { path: '/Fiches', label: 'Ma fiche' },
  ],
  [USER_ROLES.VISITEUR]: [
    { path: '/', label: 'Accueil' },
   // { path: '/Mes_Ecoles', label: 'Nos écoles' },
   // { path: '/Nos lauréats', label: 'Nos écoles' },
    { path: '/connexion', label: 'connexion' },
    
  ],
};
